var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCompany(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.891,
    height: 17.891,
    viewBox: "0 0 19.891 17.891",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1330.39,260.482h-2.984V258.6a1.938,1.938,0,0,0-1.989-1.883h-5.967a1.938,1.938,0,0,0-1.989,1.883v1.883h-2.984a1.938,1.938,0,0,0-1.989,1.883v10.358a1.938,1.938,0,0,0,1.989,1.883h15.913a1.938,1.938,0,0,0,1.989-1.883V262.365A1.938,1.938,0,0,0,1330.39,260.482Zm-10.94-1.883h5.967v1.883h-5.967Zm10.94,14.124h-15.913v-1.883h15.913Zm0-4.708h-15.913v-5.65h2.984v1.883h1.989v-1.883h5.967v1.883h1.989v-1.883h2.984Z",
    transform: "translate(-1312.488 -256.715)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompany);
export default __webpack_public_path__ + "static/media/company.09faf445115cb22f14f850f1f3c9c10a.svg";
export { ForwardRef as ReactComponent };